import React, {PureComponent} from 'react';
import {Card, Col} from 'reactstrap';
import Chat from './Chat';

export default class ChatCard extends PureComponent {
    render() {

        let chat = [];

        if (this.props.chat && this.props.chat.length > 0) {
            chat = this.props.chat;
        }

        return (
            <Col md={12} lg={12}>

                <Chat
                    type={this.props.type}
                    userId={this.props.userId}
                    chat={chat}
                    currentUser={this.props.currentUser}
                    comment={this.props.comment}
                    commentD={this.props.commentD}
                    deleteMessage={this.props.deleteMessage}
                    updateComment={this.props.updateComment}
                    background={this.props.background}
                />

            </Col>
        )
    }
};


